<template>
  <v-col>
    <v-row>
      <v-col>
        <p class="text-h5 text-no-wrap">Client</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col align-self="center">
        <p class="text-caption">Name</p>
        <p class="text-h6">{{ name }}</p>
      </v-col>
      <v-col align-self="center">
        <p class="text-caption">Username</p>
        <p class="text-h6">{{ username }}</p>
      </v-col>
      <v-col align-self="center">
        <p class="text-caption">Default currency</p>
        <p class="text-h6">{{ defaultCurrency }}</p>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>

export default{
  name: "AccountantClientInfo",
  props: {
    name: String,
    username: String,
    defaultCurrency: String
  }
}
</script>

<style scoped>

</style>